import React, { useState } from 'react';
import Modal from '../../Modal/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import WikiAnlegenAction from './WikiAnlegenAction';

export default ({ knoten, addNewWikiToKnoten, alleTags }) => {
    const [modalOpen, toggleModal] = useState(false);

    return (
        <React.Fragment>
            <button
                className="inhaltselement-anlegen-btn btn btn-sm btn-primary d-flex align-items-center"
                title="Wiki eintrag erstellen"
                onClick={() => toggleModal(!modalOpen)}>
                <FontAwesomeIcon icon="plus" />
            </button>
            {modalOpen && (
                <Modal onClose={() => toggleModal(!modalOpen)} size="md" title={`Wiki - Eintrag erstellen in ${knoten.name} `} canClose={true}>
                    <WikiAnlegenAction toggleModal={toggleModal} knoten={knoten} addNewWikiToKnoten={addNewWikiToKnoten} alleTags={alleTags} />
                </Modal>
            )}
        </React.Fragment>
    );
};
